import React from 'react';
import { Link } from 'gatsby';
import { gqlClient } from '../../_services';
import BenefitPageLoader from '../benefitpage/loader';
import CompanyLogo from '../shares/company-logo';

const initialState = {
  loading: false,
  total_count: undefined,
  per_page: 10,
};

class CertificationCompanies extends React.Component {
  constructor(props) {
    super(props);
    this.state = initialState;
  }

  async componentWillMount() {
    await this.getCompanies();
  }

  async componentWillReceiveProps() {
    await this.getCompanies();
  }

  getCompanies = async () => {
    await this.setState({
      loading: true,
      companies: undefined,
      total_count: undefined,
    });
    const { info } = this.props;

    const api = await gqlClient.request(COMPANIES_QUERY, {
      applicableCertification: info.id,
      offset: (info.page_info.current_page - 1) * 10,
      limit: this.state.per_page,
    });

    let total_count = 0;
    if (api.companies.totalCount > 0) {
      total_count =
        api.companies.totalCount +
        (info.page_info.current_page - 1) * this.state.per_page;
    }
    await this.setState({
      loading: false,
      total_count: total_count,
      companies: api.companies.edges,
    });
  };

  generatePagging = () => {
    if (!this.state.total_count) return '';

    const { info } = this.props;
    const { page_info } = info;

    let location = `certification/${info.id}`;

    const numberOfPages = Math.ceil(
      this.state.total_count / this.state.per_page
    );

    if (numberOfPages <= 1) return;

    const firstButton = <Link to={`/${location}/`}>«</Link>;
    const lastButton = <Link to={`/${location}?page=${numberOfPages}`}>»</Link>;

    const current = <span className="active">{page_info.current_page}</span>;
    const nextOne = (
      <Link to={`/${location}?page=${page_info.current_page + 1}`}>
        {page_info.current_page + 1}
      </Link>
    );
    const nextTwo = (
      <Link to={`/${location}?page=${page_info.current_page + 2}`}>
        {page_info.current_page + 2}
      </Link>
    );
    const nextThree = (
      <Link to={`/${location}?page=${page_info.current_page + 3}`}>
        {page_info.current_page + 3}
      </Link>
    );
    const nextFour = (
      <Link to={`/${location}?page=${page_info.current_page + 4}`}>
        {page_info.current_page + 4}
      </Link>
    );
    const prevOne = (
      <Link to={`/${location}?page=${page_info.current_page - 1}`}>
        {page_info.current_page - 1}
      </Link>
    );
    const prevTwo = (
      <Link to={`/${location}?page=${page_info.current_page - 2}`}>
        {page_info.current_page - 2}
      </Link>
    );

    if (numberOfPages <= 1) return '';

    return (
      <div className="pagination w-100">
        <div className="inner">
          {page_info.current_page !== 1 ? firstButton : ''}

          {page_info.current_page - 2 > 0 ? prevTwo : ''}
          {page_info.current_page - 1 > 0 ? prevOne : ''}
          {current}
          {page_info.current_page + 1 <= numberOfPages ? nextOne : ''}
          {page_info.current_page + 2 <= numberOfPages ? nextTwo : ''}
          {page_info.current_page + 3 <= numberOfPages ? nextThree : ''}
          {page_info.current_page + 4 <= numberOfPages ? nextFour : ''}

          {page_info.current_page !== numberOfPages ? lastButton : ''}
        </div>
      </div>
    );
  };

  render() {
    const { info } = this.props;
    const { loading, total_count, companies } = this.state;

    return (
      <div className="row mx-0 list-companies latest-companies">
        <div className="col-8 pl-0 list-companies-title">
          <span className="text-green">{info.page_info.header}</span>
        </div>
        <div className="col-4 pr-0 list-companies-count text-right">
          {total_count !== undefined && `${total_count}件`}
          {loading && <BenefitPageLoader />}
        </div>

        {companies &&
          companies.map((company) => (
            <div key={company.node.id} className="single-company-wrap">
              <Link className="w-100" to={`/company/${company.node.id}/`}>
                <div className="row mx-0 single-company">
                  <div className="col-md-2 col-6 text-center">
                    <CompanyLogo path={company.node.logo_path} />
                  </div>
                  <div className="col-md-5 col-6 pt-3">
                    <p className="company-industry">{company.node.industry}</p>
                    <p className="company-name">{company.node.name}</p>
                  </div>
                  <div className="col-md-5 col-12 pt-4 view-company-wraper">
                    <span className="view-company">この企業の働き方をみる</span>
                  </div>
                  <div className="col-12 company-benefits">
                    {company.node.benefits.map((benefit) => (
                      <div className="company-benefit" key={benefit.id}>
                        {benefit.subcategory.name}
                      </div>
                    ))}
                  </div>
                </div>
              </Link>
            </div>
          ))}

        {/* pagination */}
        {this.generatePagging()}
      </div>
    );
  }
}

const COMPANIES_QUERY = `
  query CompaniesQuery(
    $name: String
    $applicableCertification: String
    $offset: Int
    $limit: Int
  ) {
    companies(
      first: $limit
      name: $name
      applicableCertification: $applicableCertification
      offset: $offset
    ) {
      totalCount
      edges {
        node {
          id
          name
          address
          industry
          logo_path
          benefits {
            id
            applicable
            subcategory {
              name
            }
          }
        }
      }
    }
  }
`;

export default CertificationCompanies;
